import axios from 'axios';
import path from 'path-browserify';

import { isRegularStart } from '@/utils';

// Request wrapper
export const requestWrapper = axios.create({
  baseURL: path.join(import.meta.env.BASE_URL, '/api'),
});

export function logout() {
  if (isRegularStart) {
    window.location.href = path.join(import.meta.env.BASE_URL, '/login');
  } else {
    requestWrapper.post('/a12n/refresh/logout').finally(() => {
      requestWrapper.post('/a12n/access/logout').finally(() => {
        /**
         * Send the user to the sign in page without using the javascript router
         * This will lead to a page refresh which is what we want :
         * a page refresh will clear all persisting data in react query
         */
        window.location.href = path.join(import.meta.env.BASE_URL, '/login');
      });
    });
  }
}

requestWrapper.interceptors.response.use(
  //if no error you get the response
  (response) => response,
  (error) => {
    const { status } = error.response;
    const originalRequest = error.config;
    if (
      // If the request fails with 401 or 422
      // and is NOT a refresh or a logout request
      (status === 401 || status === 422) &&
      !['/refresh', '/logout'].some((x) => originalRequest.url.includes(x))
    ) {
      let refreshed = false;
      return requestWrapper
        .post('/a12n/refresh')
        .then(() => {
          // set refreshed to true to allow the original request to fail 401 again, even after a successful refresh.
          refreshed = true;
          return axios(originalRequest);
        })
        .catch((err) => {
          // If the user authentication can't be refreshed, the user is loged out.
          // Except if the refresh has been successful already.
          // This will allow the request to fail 401 again for another reason than an expired token
          if (!refreshed) {
            logout();
          } else {
            throw err;
          }
        });
    }
    throw error;
  },
);
